<template>
  <div class="matchingImage">
    <figure>
      <img :src="avatar" alt="미국 국기" @error="setAvatar" />
    </figure>
    <h6 class="matchingImageLabel">
      {{ item.company }}
    </h6>
    <h5 style="color: #954A48" class="matchingImageSubLabel">
      {{ item.name }}
      <span
        class="label"
        :style="`background-color: ${chipColor(item.classification)}`"
      >
        {{ chipText(item.classification) }}
      </span>
    </h5>
  </div>
</template>

<script>
import matchingColorMixins from "@/mixins/matching-color-mixins";
import { ROLE } from "@/data/role";
export default {
  name: "UserAdminDirectMatching",
  mixins: [matchingColorMixins],
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      avatar: this.item.avatar,
    };
  },
  methods: {
    setAvatar() {
      this.avatar = this.getDefaultAvatar(ROLE.USER);
    },
  },
  watch: {
    "item.avatar": {
      handler(val) {
        this.avatar = this.getAvatarLink(val, this.getDefaultAvatar(ROLE.USER));
      },
      immediate: true,
    },
  },
};
</script>
